import { Box, Stack, VStack } from '@chakra-ui/react';
import { useMultiStyleConfig } from '@chakra-ui/system';
import React from 'react';

import { FramedImage } from '../Image';
import Link from '../Link';
import { H3, ImageCaption, Text } from '../Text';

interface FeaturedLinkProps {
  invert: boolean;
  image: StaticImageDef | React.ReactElement;
  imageCaption?: string | null;
  content: React.ReactElement;
  link: {
    title: string;
    content: string;
    icon: React.ReactElement;
    href: string;
  };
}

const FeaturedLink: React.FC<FeaturedLinkProps> = ({
  invert,
  image,
  imageCaption,
  content,
  link,
}) => {
  const styles = useMultiStyleConfig('FeaturedLink', { invert });
  return (
    <Stack spacing={4} sx={styles.container}>
      <Box sx={styles.image}>
        <FramedImage image={image} actionLabel={link.title} href={link.href} />
        {imageCaption && <ImageCaption>{imageCaption}</ImageCaption>}
      </Box>
      <VStack sx={styles.content}>
        {content}
        <Link to={link.href} arrow>
          {link.icon}
          <VStack sx={styles.linkText}>
            <Text as="b">{link.title}</Text>
            <Text>{link.content}</Text>
          </VStack>
        </Link>
      </VStack>
    </Stack>
  );
};

export default FeaturedLink;
